








import { Vue, Component, Prop } from "vue-property-decorator";
import { isWishope } from "@/common/utils";

@Component
export default class Checkbox extends Vue {
  @Prop({ type: Boolean, default: false }) readonly big!: boolean;

  get isWishope() {
    return isWishope();
  }
};
